<template>
  <div>
    <el-row>
      <el-col>
        <div class="config-tabs-ctr" :class="isNewDesignEnabled() ? 'newDesign':''">
          <el-tabs
            autoid="cust-tool-features-tab-cnr"
            v-model="activeName"
            @tab-click="handleTabClick"
            class="y-tabs"
          >
            <el-tab-pane
              v-for="item in tabs"
              :key="item.name"
              :label="item.title"
              :name="item.name"
            ></el-tab-pane>
            <features-tab v-show="showFeaturesTab" ref="featuresTab" />
            <design-tab v-show="showDesignTab" />
            <text-tab v-show="showTextTab" ref="textTab" />
            <router-view v-show="showRouterView"></router-view>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import FeaturesTab from './features.vue'
import DesignTab from './design.vue'
import TextTab from './text.vue'
export default {
  name: 'SubMenu',
  components: {
    'features-tab': FeaturesTab,
    'design-tab': DesignTab,
    'text-tab': TextTab
  },
  data() {
    return {
      tabs: [
        {
          title: 'Features',
          name: 'features'
        },
        {
          title: 'Design',
          name: 'design'
        },
        {
          title: 'Text',
          name: 'text'
        }
      ],
      activeName: 'features',
      showFeaturesTab: false,
      showDesignTab: false,
      showTextTab: false,
      showRouterView: false
    }
  },
  computed: {},
  created() {
    this.showFeaturesTab = true
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name == 'features') {
        this.showFeaturesTab = true
        this.showDesignTab = false
        this.showTextTab = false
      } else if (tab.name == 'design') {
        this.showFeaturesTab = false
        this.showDesignTab = true
        this.showTextTab = false
      } else if (tab.name == 'text') {
        this.showFeaturesTab = false
        this.showDesignTab = false
        this.showTextTab = true
      }
    },
    isNewDesignEnabled() {
      return this.$enableNewDesign
    }
  }
}
</script>

<style>
</style>
